module.exports = __webpack_public_path__ + "static/body_8-216d2da15793390961835b2cacf465e7.png";